import { IconButton } from '../../ui/controls.js';

/** Zoom out / in / fit buttons overlaid on a zoomable preview. */
export function ViewBar({ onOut, onIn, onFit, fitTitle = 'Fit to view (double click)' }: { onOut: () => void; onIn: () => void; onFit: () => void; fitTitle?: string }) {
  return (
    <div className="gen-pv-bar" role="toolbar" aria-label="Preview view controls" onPointerDown={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
      <IconButton icon="minus" title="Zoom out" size={13} onClick={onOut} />
      <IconButton icon="plus" title="Zoom in" size={13} onClick={onIn} />
      <IconButton icon="focus" title={fitTitle} size={13} onClick={onFit} />
    </div>
  );
}
